<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.CV_Topic"
            placeholder="标题"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-select v-model="filters.CV_State">
            <el-option
              label="--请选择审核状态--"
              :value="-1"
              key="-1"
            ></el-option>
            <el-option label="审核中" :value="0" key="0"></el-option>
            <el-option label="审核通过" :value="1" key="1"></el-option>
            <el-option label="审核未通过" :value="2" key="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-select v-model="filters.CV_PublishState">
            <el-option
              label="--请选择发布状态--"
              :value="-1"
              key="-1"
            ></el-option>
            <el-option label="未发布" :value="0" key="0"></el-option>
            <el-option label="已发布" :value="1" key="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="CV_Topic" label="标题"></el-table-column>
      <el-table-column
        prop="CV_VideoTime"
        label="时长"
        width="100"
      ></el-table-column>
      <!-- <el-table-column prop="" label="审核状态" width="100">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.CV_State == 0">审核中</el-tag>
          <el-tag type="success" v-else-if="scope.row.CV_State == 1"
            >审核通过</el-tag
          >
          <el-tag type="warning" v-else>审核未通过</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="" label="发布状态" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.CV_PublishState == 1"
            >已发布</el-tag
          >
          <el-tag type="warning" v-else>未发布</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="CV_BrowsCount"
        label="播放量"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="CV_AddTime"
        label="添加时间"
        width="180"
      ></el-table-column>

      <el-table-column
        label="操作"
        width="200"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            style="padding-left: 10px"
            v-for="item in tableButtonList"
            v-bind:key="item.id"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增编辑 -->
    <el-dialog
      title="新增/编辑"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="CV_Video" label="上传视频">
          <div style="display: flex; align-items: center">
            <div class="" v-if="ruleForm.CV_Video">
              <el-link
                :href="ruleForm.CV_Video"
                :disabled="!ruleForm.CV_Video"
                target="_blank"
                type="primary"
                ><i class="el-icon-view el-icon--right"></i>
              </el-link>
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload2"
                v-model="fileList2"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload2"
                @on-update="handleOnUpdate2"
                :accept="accept2"
                color="#1890ff"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="CV_Picture" label="上传图片">
          <div style="display: flex; align-items: center">
            <div class="picDiv" v-if="ruleForm.CV_Picture">
              <img
                :src="
                  ruleForm.CV_Picture +
                  '?x-oss-process=image/resize,h_200,w_360,m_fixed'
                "
              />
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload"
                v-model="fileList"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload"
                @on-update="handleOnUpdate"
                :accept="accept"
                color="#1890ff"
              />
              <span style="font-size: 12px">图片尺寸：360*200（宽*高）</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="CV_Topic" label="视频主题">
          <el-input
            placeholder="视频主题"
            v-model="ruleForm.CV_Topic"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="CV_Type">
          <el-radio-group v-model="ruleForm.CV_Type">
            <el-radio :label="4">学习资源</el-radio>
            <el-radio :label="2">活动录播</el-radio>
            <el-radio :label="1">产品介绍</el-radio>
            <el-radio :label="3">案例研究</el-radio>
            <el-radio :label="0">企业介绍</el-radio>
            <el-radio :label="6">广告视频</el-radio>
            <el-radio :label="5">其他视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收费" prop="CV_IsFree">
          <el-radio-group v-model="ruleForm.CV_IsFree" @change="isFreeChange">
            <el-radio :label="0">免费</el-radio>
            <el-radio :label="1">收费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="CV_Money" v-if="isShowMoney" label="金额">
          <el-input
            placeholder="金额"
            v-model="ruleForm.CV_Money"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="CV_TeacherName" label="讲师名称">
          <el-input
            placeholder="讲师名称"
            v-model="ruleForm.CV_TeacherName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="CV_Desc" label="视频详情">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="视频详情"
            v-model="ruleForm.CV_Desc"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import UploadPan from '@/components/Upload/index'
import { getVideoPageList, getVideoInfo, addOrUpdVideo } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { durationTrans } from '../../../util'

export default {
  data() {
    return {
      isShowMoney: false,
      fileList: [],
      fileList2: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
      accept2: '.mp4',
      listLoading: false,
      topButtonList: [],
      tableButtonList: [],
      editLoading: false,
      filters: {
        CV_Topic: '',
        CV_State: -1,
        CV_PublishState: -1,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      addFormVisible: false, // 新增弹框
      // 新增弹窗数据
      ruleForm: {
        VideoIDStr: '',
        CV_Topic: '',
        CV_Video: '',
        CV_Type: -1,
        CV_IsFree: -1,
        CV_Picture: '',
        CV_Money: '',
        CV_TeacherName: '',
        CV_Desc: '',
        CV_VideoTime: '',
      },
      rules: {
        CV_Topic: [
          { required: true, message: '请输入视频主题', trigger: 'blur' },
        ],
        CV_Video: [{ required: true, message: '请上传视频', trigger: 'blur' }],
        CV_Picture: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
        CV_Type: [
          { required: true, message: '请选择分类', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请选择分类' },
        ],
        CV_IsFree: [
          { required: true, message: '请选择是否免费', trigger: 'blur' },
          { pattern: /^\+?[0-9]\d*$/, message: '请选择分类' },
        ],
        CV_TeacherName: [
          { required: true, message: '请输入讲师名称', trigger: 'blur' },
        ],
        CV_Money: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
            message: '请输入正确格式的金额',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  components: {
    UploadPan,
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 新增客户用户
    handleAdd() {
      this.addOrUpd()
    },

    handleEdit() {
      getVideoInfo(this.currentRow.VideoIDStr).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
        }
      })
      this.addOrUpd()
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdVideo(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.addFormVisible = false
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    handleClose() {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getVideoPageList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleDelete() {
      let row = this.currentRow
      console.log(row)
      this.options = []
      if (!row) {
        this.$message({
          message: '请选择一行数据！',
          type: 'error',
        })
        return
      }
      delVideo(this.currentRow.VideoIDStr).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      console.log('handleOnUpdate')
      console.log(obj)
      // ?x-oss-process=image/resize,h_200,w_360,m_fixed
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.CV_Picture = url
    },

    handleCloseUpload2() {
      this.fileList2 = []
    },
    handleOnUpdate2(obj) {
      console.log('handleOnUpdate2')
      console.log(obj)
      this.ruleForm.CV_VideoTime = durationTrans(obj.Duration)
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.CV_Video = url
    },
    addOrUpd() {
      this.addFormVisible = true
    },
    isFreeChange(val) {
      if (val == 0) {
        this.isShowMoney = false
      } else {
        this.isShowMoney = true
      }
    },
  },
  mounted() {
    this.handleQuery()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}

.editor-upload-btn {
  z-index: 3000 !important;
}
.picDiv {
  width: 360px;
  height: 200px;
  background-color: red;
  border: 1px solid grey;
}
</style>
